
<!-- MEASUREMENT INFORMATION CARD -->
@if (measurement(); as m) {
  <div class="relative flex flex-col md:block">
    <div class="md:absolute md:top-0 md:bottom-0 md:left-0 md:w-[20rem]">
      <ng-content></ng-content>
    </div>
    <div class="md:ml-[21rem] flex-grow">
  <p-card>
    <ng-template #title>{{m.name}}</ng-template>
    <ng-template #subtitle>{{ 'measurement.types.MaturityMeasurement' | translate }} - {{(m.active ? 'measurement.ongoing' : 'measurement.finished') | translate}}</ng-template>
    <!-- content -->
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-clock"></i></div>
      <div class="item-text">
        <div class="item-title">{{ m.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</div>
        <div class="item-line">{{ "measurement.created" | translate }}</div>
      </div>
    </div>
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-clock-rotate-left"></i></div>
      <div class="item-text">
        <div class="item-title">{{ m.updatedAt | date:'dd/MM/yyyy HH:mm:ss' }}</div>
        <div class="item-line">{{ "measurement.updated" | translate }}</div>
      </div>
    </div>

    <p-divider></p-divider>

    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-align-left"></i></div>
      <div class="item-text">
        <div class="item-title">{{m.description ? m.description : '-'}}</div>
        <div class="item-line">{{ "measurement.card.description" | translate }}</div>
      </div>
    </div>
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-mobile"></i></div>
      <div class="item-text">
        <div class="item-title">{{ device()?.name }}</div>
        <div class="item-line">{{ "measurement.card.device" | translate }}</div>
      </div>
    </div>
    <ng-template #footer>
      <p-confirmdialog />
      <div class="flex flex-wrap gap-2">
        @if (rbac.canEditProject()) {
          <p-button (click)="editMeasurement()" color="primary"><i class="fa-solid fa-edit"></i> {{ "measurement.edit" | translate }}</p-button>
        }
        @if (m.active && rbac.canEditProject()) {
          <p-button (click)="finishMeasurement($event)" severity="danger"><i class="fa-solid fa-link-slash"></i>{{ "measurement.finish" | translate }}</p-button>
        }
        @if (m.active && rbac.canEditProject()) {
          <p-button (click)="changeDevice(m)" severity="secondary"><i class="fa-solid fa-shuffle"></i>{{ "measurement.change_device" | translate }}</p-button>
        }
      </div>
    </ng-template>
  </p-card>
    </div>
  </div>
}

<p-divider></p-divider>

@if (measurement()) {
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <cosmos-corrosion-insights-card [corrosionData]="corrosionData()"></cosmos-corrosion-insights-card>
    <!-- right side -->
    <div class="col-span-2 grid gap-4 min-w-0">
      <!-- POTENTIAL CHART -->
      <p-card class="min-w-0">
        <ng-template #title>{{ "measurement.corrosion.corrosion-potential.chart.title" | translate }}</ng-template>
        <ng-template #subtitle>{{ "measurement.chart.subtitle" | translate }}</ng-template>
        <cosmos-dynamic-line-chart
          [dataObject]="corrosionData()"
          [datasets]="['potential']"
          [labels]="['potential']"
          [chartId]="'safecor_potential'">
        </cosmos-dynamic-line-chart>
      </p-card>
      <!-- RP CHART -->
      <p-card class="min-w-0">
        <ng-template #title>{{ "measurement.corrosion.corrosion-rp.chart.title" | translate }}</ng-template>
        <ng-template #subtitle>{{ "measurement.chart.subtitle" | translate }}</ng-template>
        <cosmos-dynamic-line-chart
          [dataObject]="corrosionData()"
          [datasets]="['rp']"
          [labels]="['rp']"
          [chartId]="'safecor_rp'">
        </cosmos-dynamic-line-chart>
      </p-card>
      <!-- ROHM -->
      <p-card class="min-w-0">
        <ng-template #title>{{ "measurement.corrosion.corrosion-rohm.chart.title" | translate }}</ng-template>
        <ng-template #subtitle>{{ "measurement.chart.subtitle" | translate }}</ng-template>
        <cosmos-dynamic-line-chart
          [dataObject]="corrosionData()"
          [datasets]="['rohm']"
          [labels]="['rohm']"
          [chartId]="'safecor_rohm'">
        </cosmos-dynamic-line-chart>
      </p-card>
    </div>
  </div>
}
